<template>
  <div class="card">
    <div class="toolbar">
      <select v-model="query.action">
        <option value="">全部操作</option>
        <option value="create">新增</option>
        <option value="update">修改</option>
        <option value="delete">删除</option>
      </select>
      <button @click="handleSearch">查询</button>
    </div>

    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>操作人</th>
          <th>模块</th>
          <th>操作类型</th>
          <th>对象</th>
          <th>对象ID</th>
          <th>操作时间</th>
          <th>变更前</th>
          <th>变更后</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in list" :key="row.id">
          <td>{{ row.id }}</td>
          <td>{{ row.operator_id || '-' }}</td>
          <td>{{ row.module }}</td>
          <td>{{ row.action }}</td>
          <td>{{ row.target_type }}</td>
          <td>{{ row.target_id }}</td>
          <td>{{ row.created_at }}</td>
          <td><pre>{{ row.before_data }}</pre></td>
          <td><pre>{{ row.after_data }}</pre></td>
        </tr>
      </tbody>
    </table>

    <div class="pagination">
      <div class="pagination-left">
        <span>共 {{ total }} 条</span>
        <span>第 {{ query.page }} / {{ totalPages }} 页</span>
      </div>
      <div class="pagination-right">
        <label>每页</label>
        <select v-model.number="query.pageSize" @change="handlePageSizeChange">
          <option :value="10">10</option>
          <option :value="20">20</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
        <button :disabled="query.page <= 1" @click="changePage(query.page - 1)">上一页</button>
        <button :disabled="query.page >= totalPages" @click="changePage(query.page + 1)">下一页</button>
      </div>
    </div>
  </div>
</template>

<script>
import { logList } from '@/api/priceMonitor'

export default {
  name: 'OperationLogs',
  data() {
    return {
      query: { page: 1, pageSize: 20, action: '' },
      list: [],
      total: 0
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.total / this.query.pageSize))
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      const res = await logList(this.query)
      if (res.code === 200) {
        const data = res.data || {}
        this.list = data.list || []
        this.total = Number(data.count || 0)
      } else {
        alert(res.msg || '查询失败')
      }
    },
    handleSearch() {
      this.query.page = 1
      this.fetchData()
    },
    changePage(page) {
      const target = Math.min(this.totalPages, Math.max(1, Number(page) || 1))
      if (target === this.query.page) return
      this.query.page = target
      this.fetchData()
    },
    handlePageSizeChange() {
      this.query.page = 1
      this.fetchData()
    }
  }
}
</script>

<style scoped>
.card { background: #fff; border-radius: 8px; padding: 16px; }
.toolbar { display: flex; gap: 10px; margin-bottom: 12px; }
select, button { height: 34px; padding: 0 10px; border: 1px solid #d1d5db; border-radius: 6px; }
button { cursor: pointer; background: #fff; }
button:disabled { cursor: not-allowed; opacity: 0.5; }
table { width: 100%; border-collapse: collapse; }
th, td { border: 1px solid #e5e7eb; padding: 8px; font-size: 12px; text-align: left; vertical-align: top; }
pre { margin: 0; max-width: 260px; max-height: 120px; overflow: auto; white-space: pre-wrap; word-break: break-all; }
.pagination { display: flex; justify-content: space-between; align-items: center; gap: 12px; margin-top: 12px; }
.pagination-left, .pagination-right { display: flex; align-items: center; gap: 8px; font-size: 12px; color: #374151; }
</style>
